import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any, screens: any) => ({
  form: css`
    max-width: ${screens.lg ? "624px" : "100%"};
  `,
  productImage: css``,
  footerActions: css`
    button {
      min-width: 120px;
    }
  `,
}));

export const useFormLoyaltyConfirmStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
